








































































































































































































































































































































































































































import Vue from "vue";
import { Input } from "../../../directives/Input";
import { Component, Inject } from "vue-property-decorator";
import Accordion from "../../shared/Accordion.vue";
import Modal from "../../shared/modal/Modal.vue";
import {
  AddressDTO,
  ContactDTO,
  ContactReferenceDTO,
  ContactType,
  CountryDTO,
  ZipRegistryEntryDto,
  SubcountryDTO
} from "../../../model/data.model";
import { Pageable, TranslatedCountryDTO } from "../../../model/component.model";
import ContactAddressDetail from "./ContactAddressDetail.vue";
import i18n from "../../../lang/i18n";
import {
  email,
  minLength,
  required,
  requiredIf
} from "vuelidate/lib/validators";
import isPhone from "../../../definitions/telephone-validator";
import isBlank from "../../../definitions/whitespace-validator";
import { ContactService } from "../../../services/ContactService";
import { ShipmentService } from "@/services/ShipmentService";
import VueScrollTo from "vue-scrollto";
import store from "@/vuex/store";
import { fieldSorter } from "@/services/Helpers";
import provinceValidator from "../../../definitions/province-validator";
import { use } from "vue/types/umd";

@Component({
  directives: {
    MbeInput: Input
  },
  components: {
    MbeContactAddressDetail: ContactAddressDetail,
    MbeAccordion: Accordion,
    MbeModal: Modal
  },
  validations() {
    return {
      contact: {
        firstname: {
          required,
          minLength: minLength(2),
          isBlank
        },
        addresses: {
          $each: {
            address: {
              required
            },
            city: {
              required
            },
            state: {
              required: requiredIf(function(this: ContactDetails) {
                return false;
              })
            },
            zipCode: {
              required
            },
            countryId: {
              required
            },
            province: {
              required: requiredIf(function(this: ContactDetails) {
                return false;
              }),
              validator: provinceValidator(
                this.$data.contact && this.$data.contact.addresses
                  ? this.$data.contact.addresses[0].countryName
                  : ""
              )
            }
          }
        }
      },
      contactEmail: {
        email
      },
      contactEmail2: {
        email
      },
      contactTelephone: {
        isPhone
      },
      contactTelephone2: {
        isPhone
      },
      contactFax: {
        isPhone
      },
      contactName: {
        required: requiredIf(function(this: ContactDetails) {
          return this.$store.getters["customer/info"].tenantId !== 3;
        })
      }
    };
  }
})
export default class ContactDetails extends Vue {
  @Inject() contactService: ContactService;
  contact: ContactDTO = {} as ContactDTO;

  countries: TranslatedCountryDTO[] = [];

  deletionModalVisible = false;
  userAuthor = this.$store.getters.user.username as string;

  res = false;
  mmr = false;
  ltz = false;
  address = null;
  subcountries = null;
  subcountry = null;
  zipRegistryLocations: ZipRegistryEntryDto[] = [];
  showZipRegistryLocationModal = false;
  selectZipRegistry: ZipRegistryEntryDto = {} as ZipRegistryEntryDto;
  openedAddress = 0;
  nameSelected = 1 as number;
  defaultPickup = false as boolean;
  startingDefaultPickup: boolean;

  addressesPickups = [
    {
      name: "contacts",
      key: 1
    },
    {
      name: "pickups",
      key: 2
    }
  ];

  updateSelected(item: any) {
    this.nameSelected = item.key;
  }

  isActive(item: any): boolean {
    return item.key === this.nameSelected;
  }
  get avatarInitials() {
    const firstname =
      this.contact.firstname === undefined || this.contact.firstname === null
        ? ""
        : this.contact.firstname;
    const lastname =
      this.contact.lastname === undefined || this.contact.lastname === null
        ? ""
        : this.contact.lastname;
    return (firstname + " " + lastname)
      .match(/\b\w/g)
      .join("")
      .substring(0, 4)
      .toUpperCase();
  }

  get avatarName() {
    const firstname =
      this.contact.firstname === undefined || this.contact.firstname === null
        ? ""
        : this.contact.firstname;
    const lastname =
      this.contact.lastname === undefined || this.contact.lastname === null
        ? ""
        : this.contact.lastname;
    return firstname + " " + lastname;
  }

  getContactReferenceValue(contactType: string): string {
    if (this.contact && this.contact.contactsReference) {
      const filteredReferences = this.contact.contactsReference.filter(
        item => item.type === contactType
      );

      return filteredReferences.length > 0 ? filteredReferences[0].value : "";
    } else {
      return "";
    }
  }

  setContactReferenceValue(contactType: string, value: string) {
    let updated = false;
    this.contact.contactsReference.forEach(item => {
      if (item.type === contactType) {
        updated = true;
        item.value = value;
      }
    });

    if (!updated) {
      const ref = {} as ContactReferenceDTO;
      ref.type = contactType as ContactType;
      ref.value = value;
      this.contact.contactsReference.push(ref);
    }
  }

  get contactTelephone() {
    return this.getContactReferenceValue("TELEPHONE1");
  }
  set contactTelephone(value: string) {
    this.setContactReferenceValue("TELEPHONE1", value);
  }
  get contactTelephone2() {
    return this.getContactReferenceValue("TELEPHONE2");
  }
  set contactTelephone2(value: string) {
    this.setContactReferenceValue("TELEPHONE2", value);
  }
  get contactEmail() {
    return this.getContactReferenceValue("EMAIL1");
  }
  set contactEmail(value: string) {
    this.setContactReferenceValue("EMAIL1", value);
  }
  get contactEmail2() {
    return this.getContactReferenceValue("EMAIL2");
  }
  set contactEmail2(value: string) {
    this.setContactReferenceValue("EMAIL2", value);
  }
  get contactFax() {
    return this.getContactReferenceValue("FAX");
  }
  set contactFax(value: string) {
    this.setContactReferenceValue("FAX", value);
  }
  get contactName() {
    return this.getContactReferenceValue("CONTACT_NAME");
  }
  set contactName(value: string) {
    this.setContactReferenceValue("CONTACT_NAME", value);
  }

  get deleteVisible() {
    return this.$route.params.id !== "new"; // && this.oldCustomer.active;
  }

  get id() {
    return this.$route.params.id;
  }

  get molUsername() {
    return this.$route.params.molUsername;
  }

  created() {
    if (this.$route.params.typeAddress !== undefined) {
      this.nameSelected = Number(this.$route.params.typeAddress);
    } else {
      this.nameSelected = 1;
    }
    let id: number;
    if (this.id === "new") {
      id = 0;
    } else {
      id = Number(this.id);
    }
    if (!this.$store.getters["customer/config"].pickupEnabled) {
      this.addressesPickups = [
        {
          name: "contacts",
          key: 1
        }
      ];
    }

    this.contactService
      .getContact(id, this.nameSelected)
      .then((contact: ContactDTO) => {
        this.contact = contact;
        if (contact.addresses[0].flavour == "RESIDENTIAL") {
          this.res = true;
        }
        if (contact.addresses[0].flavour == "MMR") {
          this.mmr = true;
        }
        if (contact.addresses[0].ltz == true) {
          this.ltz = true;
        }
        if (this.$route.params.id === "new") {
          this.defaultPickup = false;
          this.startingDefaultPickup = false;
        } else {
          contact.addresses[0].type === "OPERATION"
            ? (this.addressesPickups = this.addressesPickups.filter(
                item => item.key === 2
              ))
            : (this.addressesPickups = this.addressesPickups.filter(
                item => item.key === 1
              ));
          if (
            this.contact.id ==
            this.$store.getters.customer.config.defaultPickupContactId
          ) {
            this.defaultPickup = true;
            this.startingDefaultPickup = true;
          } else {
            this.defaultPickup = false;
            this.startingDefaultPickup = false;
          }
        }
      });

    store.cache
      .dispatch("cachemod/getCountries")
      .then((countries: CountryDTO[]) => {
        countries.sort((a: CountryDTO, b: CountryDTO) =>
          a.name < b.name ? -1 : 1
        );
        this.countries = countries
          .map(
            (country: CountryDTO): TranslatedCountryDTO => {
              const translatedCountry = { ...country } as TranslatedCountryDTO;
              translatedCountry.translatedName = this.$t(
                "country_" + country.id
              ).toString();
              return translatedCountry;
            }
          )
          .sort(fieldSorter(["translatedName"]));
      });
  }

  mounted() {
    const addressId = this.$route.params.address;
    if (addressId !== undefined) {
      this.openedAddress = Number(addressId);
      setTimeout(() => {
        VueScrollTo.scrollTo("#address" + addressId, 350);
      }, 500);
    }
  }

  showAddressForm = false;

  // Save
  get saveDisable() {
    if (this.$v.$invalid) {
      return true;
    }

    return false;
  }

  toggleShowZipRegistryLocationModal() {
    this.showZipRegistryLocationModal = !this.showZipRegistryLocationModal;
  }

  saveContact() {
    this.contact.molUsername = this.userAuthor;
    if (this.nameSelected == 2) {
      this.contact.addresses[0].type = "OPERATION";
      if (this.$store.getters["customer/config"].tenantId !== 5) {
        this.contact.addresses[0].ltz = this.ltz;
        if (this.res == true) {
          this.contact.addresses[0].flavour = "RESIDENTIAL";
        } else if (this.mmr == true) {
          this.contact.addresses[0].flavour = "MMR";
        } else {
          this.contact.addresses[0].flavour = "NONE";
        }
      }
    } else if (this.nameSelected == 1) {
      this.contact.addresses[0].type = "SHIPMENT";
    }
    this.contact.defaultContact = this.defaultPickup;
    this.contactService
      .saveContact(this.contact)
      .then((contact: ContactDTO) => {
        if (this.defaultPickup !== this.startingDefaultPickup) {
          if (this.$route.params.id !== "new") {
            if (this.defaultPickup == true) {
              this.contactService.defaultPickup(
                contact.id,
                this.$store.getters.customer.config.customerId
              );
              this.$store.state.customer.config.defaultPickupContactId =
                contact.id;
            } else if (this.defaultPickup == false) {
              this.contactService.deleteDefaultPickup(
                contact.id,
                this.$store.getters.customer.config.customerId
              );
              this.$store.state.customer.config.defaultPickupContactId = null;
            }
          } else {
            if (this.defaultPickup == true) {
              this.contactService.defaultPickup(
                contact.id,
                this.$store.getters.customer.config.customerId
              );
              this.$store.state.customer.config.defaultPickupContactId =
                contact.id;
            }
          }
        }
        this.$snotify
          .success(this.$t("notification_recipient_saved").toString(), {
            timeout: 800
          })
          .on("destroyed", () =>
            this.$router.push({
              name: "ContactsList",
              params: { typeAddress: String(this.nameSelected) }
            })
          );
      })
      .catch(err => {
        this.$snotify.error(err.response.data.message);
      });
  }

  // Cancel
  restoreContact() {
    let typeAddress = "";
    if (this.nameSelected == 1) {
      typeAddress = "SHIPMENT";
    } else {
      typeAddress = "OPERATION";
    }
    if (this.contact.id === undefined) {
      this.contact = {
        firstname: "",
        lastname: "",
        gender: "",
        contactType: "CONTACT",
        birthDate: "1980-01-01",
        molUsername: this.userAuthor,
        addresses: [
          {
            type: typeAddress,
            address: "",
            city: "",
            state: "",
            zipCode: "",
            countryName: "",
            countryId: "",
            province: ""
          } as AddressDTO
        ] as AddressDTO[],
        contactsReference: [
          { type: "EMAIL1", value: "" } as ContactReferenceDTO
        ]
      } as ContactDTO;
    } else {
      this.contactService
        .getContact(parseInt(this.id), this.nameSelected)
        .then((contact: ContactDTO) => {
          this.contact = contact;
        })
        .catch(err => {
          this.$snotify.error(err.response.data.message);
        });
    }
  }

  // Delete
  closeDeletionModal() {
    this.deletionModalVisible = false;
  }

  searchZipRegistryLocation() {
    this.selectZipRegistry = {} as ZipRegistryEntryDto;

    ShipmentService.prototype
      .getZipRegistry(
        this.contact.addresses[0].countryId,
        this.contact.addresses[0].zipCode,
        this.contact.addresses[0].province,
        this.contact.addresses[0].city
      )
      .then((res: any) => {
        const data = res.data as Pageable<ZipRegistryEntryDto>;
        if (data) {
          if (data.content.length === 1) {
            this.selectLocation(data.content[0], true);
          } else {
            if (data.content.length > 0) {
              this.zipRegistryLocations = data.content;
              this.showZipRegistryLocationModal = true;
            } else {
              if (this.address.province || this.address.city) {
                this.address.province = "";
                this.address.city = "";
                this.searchZipRegistryLocation();
              } else {
                this.$snotify.error(String(i18n.t("no_location_found")));
              }
            }
          }
        }
      })
      .catch((err: any) => {
        this.$snotify.error(err.message);
      });
  }

  selectLocation(location: ZipRegistryEntryDto, fromWorldIcon?: boolean) {
    this.contact.addresses[0].countryId = location.id.country;
    this.contact.addresses[0].province =
      location.id && location.id.province ? location.id.province : "";
    this.contact.addresses[0].city = location.id.townName;

    const currentZipCode = this.contact.addresses[0].zipCode;
    if (currentZipCode !== "") {
      if (
        currentZipCode >= location.id.postcodeFrom &&
        currentZipCode <= location.id.postcodeUntil
      ) {
        this.contact.addresses[0].zipCode = currentZipCode;
      }
    } else {
      this.contact.addresses[0].zipCode = location.id.postcodeFrom;
    }
    this.selectZipRegistry = location;

    if (fromWorldIcon) {
      const storeZipCode = this.$store.getters["customer/storeAddresses"][0]
        .zipCode;
      const storeIsoCode = this.$store.getters["customer/storeAddresses"][0]
        .countryId;
      store.cache
        .dispatch(
          "cachemod/getSubcountries",
          {
            countryId: this.contact.addresses[0].countryId,
            zipcode: this.contact.addresses[0].zipCode,
            storeZipCode: storeZipCode,
            storeIsoCode: storeIsoCode
          },
          { timeout: store.state["cachemod"].timeouts.subCountries }
        )
        .then((res: SubcountryDTO[]) => {
          if (res !== undefined) {
            this.subcountries = res;
            if (this.subcountries.length === 1) {
              // this.address.cee = this.subcountries[0].cee;
              this.subcountry = this.subcountries[0];
            }
            if (this.subcountries.length === 0) {
              this.subcountry = null;
            }
          } else {
            if (this.subcountries.length > 0) {
              this.subcountries = [];
            }
          }
        })
        .catch(() =>
          this.$snotify.error(this.$t("error_getting_subcountries").toString())
        );
    }
  }

  confirmDeletion() {
    this.contactService.deleteContact(this.id).then(() => {
      this.$router.push({ name: "ContactsList" });
    });
  }

  addAddress() {
    const newAddress = {
      type: this.nameSelected == 1 ? "SHIPMENT" : "OPERATION",
      address: "",
      city: "",
      state: "",
      zipCode: "",
      countryName: "",
      countryId: "",
      province: ""
    } as AddressDTO;
    this.contact.addresses.push(newAddress);
    this.changeOpenedAddress(this.contact.addresses.length - 1);
  }

  deleteAddress(address: AddressDTO) {
    this.contactService.deleteAddress(address.id).then((res: any) => {
      if (res.type === "SUCCESS") {
        this.contact.addresses = this.contact.addresses.filter(item => {
          return item.id !== address.id;
        });
      }
    });
  }

  changeOpenedAddress(addressIndex: any) {
    if (this.contact.addresses[addressIndex].id !== undefined) {
      const id = Number(this.contact.addresses[addressIndex].id);
      if (this.openedAddress !== id) {
        // New address opened
        this.openedAddress = id;
        return;
      }
    }

    this.openedAddress = -1;
  }
}
